<template lang="html">
  <div class="gsinfo">
    <div class="divider_line">
      <span>基本信息</span>
    </div>
    <div class="info_div">
        <div class="infoList">
            <div class="info">
                <div class="row">
                    <div class="row-left">工商注册号</div>
                    <div class="row-right">{{detail.gs_code | empty}}</div>
                </div>
                <div class="row">
                    <div class="row-left">组织机构代码</div>
                    <div class="row-right">{{detail.jg_code | empty}}</div>
                </div>
                <div class="row">
                    <div class="row-left">企业机构类型</div>
                    <div class="row-right">{{detail.type | empty}}</div>
                </div>
                <div class="row">
                    <div class="row-left">法定代表</div>
                    <div class="row-right">{{detail.fr_name | empty}}</div>
                </div>
            </div>
            <div class="info">
                <div class="row">
                    <div class="row-left">统一社会信用代码</div>
                    <div class="row-right">{{detail.xy_code | empty}}</div>
                </div>
                <div class="row">
                    <div class="row-left">经营状态</div>
                    <div class="row-right">{{detail.state | empty}}</div>
                </div>
                <div class="row">
                    <div class="row-left">注册资本</div>
                    <div class="row-right">{{detail.zc_amount | amountPrecise(detail.unit_id,1)}}</div>
                </div>
                <div class="row">
                    <div class="row-left">所属行业</div>
                    <div class="row-right">{{detail.classify | empty}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="row-left">注册地址</div>
            <div class="row-right">{{detail.zc_address | empty}}</div>
        </div>
    </div>
    <div class="divider_line">
      <span>股东信息</span>
    </div>
    <div class="info_div">
      <div class="list_div">
        <Table :columns="tableDataColumns" :data="news_list"></Table>
      </div>
      <div class="page clear" v-if="tableData.length > 10">
          <Page :total="tableData.length" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
      </div>
    </div>
    <div class="divider_line">
      <span>变更信息</span>
    </div>
    <div class="info_div">
      <div class="list_div">
        <Table :columns="tableDataColumns1" :data="news_list1"></Table>
      </div>
      <div class="page clear" v-if="tableData1.length > 10">
          <Page :total="tableData1.length" :page-size="10" show-total class="page_list" @on-change="handlePage1"/>
      </div>
    </div>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityDetail } from '../../../service'
import {escape2Html} from '@/assets/js/common.js'
import filter from 'js/filter'
export default {
  data() {
    return {
      spinShow: true,
      params: {
        uid: this.$route.params.uid,
        type: 'gs'
      },
      tableData: [],
      news_list: [],
      tableDataColumns: [
        {title: '股东',key: 'gd_name', render: (h, params) => {
          return h('span', filter.empty(params.row.gd_name))
        }},
        {title: '持股比例',key: 'per', render: (h, params) => {
          return h('span', filter.empty(params.row.per))
        }},
        {title: '认缴金额',key: 'amount', render: (h, params) => {return h('span',filter.empty(params.row.amount_with_unit))}},
        {title: '股东类型',key: 'type', render: (h, params) => {
          return h('span', filter.empty(params.row.type))
        }},
      ],
      tableData1: [],
      news_list1: [],
      tableDataColumns1: [
        {title: '时间',key: 'change_time', render: (h, params) => {return h('span',filter.timeTrans(params.row.change_time))}},
        {title: '变更类型',key: 'type', render: (h, params) => {
          return h('span', filter.empty(params.row.type))
        }},
        {title: '变更前',key: 'c_before', render: (h, params) => {
          return h('span', {domProps: {innerHTML: filter.empty(escape2Html(params.row.c_before))}})
        }},
        {title: '变更后',key: 'c_after', render: (h, params) => {
          return h('span', {domProps: {innerHTML: filter.empty(escape2Html(params.row.c_after))}})
        }},
      ],
      detail: ''
    }
  },
  methods: {
    async getDetail() {
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if(res.gs.length != 0){
          this.$set(this.$data, 'detail', res.gs[0])
          this.$emit('callbackData', 'GsInfo')
        }else{
          const default_detail = {
            classify: '',
            create_time: null,
            djjg: '',
            fr_name: null,
            gs_code: '',
            hz_time: '',
            jg_code: null,
            jyfw: '',
            state: '',
            taxpayer_number: null,
            type: '',
            unit_id: '',
            xy_code: '',
            zc_address: '',
            zc_amount: '',
            zc_time: ''
          }
          this.datail = default_detail
        }
        this.$set(this.$data, 'tableData', res.gd)
        this.$set(this.$data, 'news_list', [...res.gd].slice(0,10))
        this.$set(this.$data, 'tableData1', res.bg)
        this.$set(this.$data, 'news_list1', [...res.bg].slice(0,10))
        this.spinShow = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    handlePage(page) {
      this.$set(this.$data, 'news_list', [...this.tableData].slice(10*(page-1),10*page))
    },
    handlePage1(page) {
      this.$set(this.$data, 'news_list1', [...this.tableData1].slice(10*(page-1),10*page))
    }
  },
  created() {
    this.getDetail()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.divider_line
  margin: 32px 0
.gsinfo
  padding: 1px 32px 32px 32px
  .divider_line:first-of-type
    margin-top: 39px
.title
  line-height: 24px
  font-size: 20px
  font-weight: bold
  position: relative
  margin: 32px 0 28px
  &:first-of-type
    margin-top: 0
  &:before
    content: ''
    position: absolute
    commonBgColor(#d9d9d9, #E9E9E9)
    height: 1px
    width: -webkit-calc(100% - 104px)
    width: calc(100% - 104px)
    top: 50%
    right: 0
.info_div
  padding: 0 18px
.infoList
  display: flex
  .info
    flex: 0 0 50%
.row
  display: flex
  font-size: 14px
  border-bottom: 1px solid
  commonBorderColor(#414556, #F3F3F3)
  &-left
    flex: 0 0 180px
    line-height: 16px
    min-height: 48px
    padding: 16px 0 16px 32px
    commonBgColor(#2A2F42, #FFFAF5)
    commonColor(#E9E9EB, #333333)
  &-right
    flex: auto
    commonColor(#BCBDC1, #666666)
    line-height: 16px
    padding: 16px 32px
    commonBgColor(#323646, #FFFFFF)
.info_div >>> .str_color
  color: #F3494B

</style>
